import { render, staticRenderFns } from "./ForecastTable.vue?vue&type=template&id=2b84b397&scoped=true&"
import script from "./ForecastTable.vue?vue&type=script&lang=js&"
export * from "./ForecastTable.vue?vue&type=script&lang=js&"
import style0 from "./ForecastTable.vue?vue&type=style&index=0&id=2b84b397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84b397",
  null
  
)

export default component.exports